import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ErrorBoundary extends Component {
  state = { hasError: false, errorMessage: 'Something went wrong' };

  static getDerivedStateFromError(error) {
    return { hasError: true, errorMessage: error.message };
  }

  componentDidCatch(error, info) {
    if (info) {
      console.log('Info: ', info);
    }
    if (error) {
      console.log('Error: ', error);
    }
    const method = error.level === 'warning' ? 'warning' : 'error';
    if (window.Rollbar && window.Rollbar[method]) {
      window.Rollbar[method](error);
    }
  }

  refresh = () => {
    // Reload the current page without the browser cache
    window.location.reload(true);
  };

  render() {
    const { hasError, errorMessage } = this.state;
    const { children } = this.props;
    if (hasError) {
      return (
        <div style={{ width: '500px', margin: '0 auto' }}>
          <h1 className="h1">Server Error - 500</h1>
          <div className="body">
            The server encountered the following error when trying to load this
            document: "{errorMessage}". If the error persists, try opening the
            document again from the link displayed in Forum.
          </div>
          <div className="flex justify-around mt4">
            <button type="button" onClick={this.refresh}>
              Try again
            </button>
          </div>
        </div>
      );
    }

    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ErrorBoundary;
